<template>
    <div>
        <v-card elevation="0">
            <v-toolbar color="#ef6b01" rounded="0" elevation="5" class="fixed-bar">
                <v-btn icon dark @click="atras"><font-awesome-icon style="font-size:23px" icon="arrow-left"/></v-btn>
                <v-card-title style="color:white" class="text-truncate text-center">Mi perfil</v-card-title>
            </v-toolbar>
            <v-card-text class="text-center mb-15 perfil-content">
                <v-row class="mt-2" style="align-items: center;">
                    <v-col cols="3" class="perfil-icon-col">
                        <v-avatar size="56" color="#fff3e0">
                            <v-icon color="orange" size="36">mdi-account</v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col cols="9" class="text-left">
                        <p class="mb-1 perfil-nombre">{{ nombreCompleto }}</p>
                        <p v-if="usuario.email" class="mb-0 perfil-dato">{{ usuario.email }}</p>
                        <p v-if="usuario.celular" class="mb-0 perfil-dato">{{ usuario.celular }}</p>
                    </v-col>
                </v-row>

                <v-divider class="mt-4" style="border-top: ridge;"></v-divider>

                <v-row class="mt-5" style="align-items: center;">
                    <v-col cols="3" class="perfil-icon-col">
                        <v-icon color="orange" style="font-size:36px">mdi-map-marker</v-icon>
                    </v-col>
                    <v-col cols="9" class="text-left">
                        <p class="mb-1 perfil-seccion">Mi dirección</p>
                        <template v-if="cliente">
                            <p class="mb-0 perfil-dato">{{ cliente.DOM }}</p>
                            <p class="mb-0 perfil-dato">{{ `${cliente.LOCALIDAD}, ${cliente.PROVINCIA}` }}, Argentina</p>
                        </template>
                        <p v-else class="mb-0 perfil-vacio">No hay una dirección cargada</p>
                    </v-col>
                </v-row>

                <v-divider class="mt-4" style="border-top: ridge;"></v-divider>

                <v-row class="mt-5" style="align-items: flex-start;">
                    <v-col cols="3" class="perfil-icon-col">
                        <v-icon color="orange" style="font-size:36px">mdi-bus</v-icon>
                    </v-col>
                    <v-col cols="9" class="text-left">
                        <p class="mb-1 perfil-seccion">Mi transporte</p>
                        <template v-if="transportes.length > 0">
                            <p
                                v-for="(item, index) in transportes"
                                :key="index"
                                class="mb-1 perfil-dato"
                            >{{ item.NOM_FANTASIA }}</p>
                        </template>
                        <p v-else class="mb-0 perfil-vacio">No hay transportes asignados</p>
                    </v-col>
                </v-row>

                <template v-if="usuario.muestraCatalogoPuntos == 1">
                    <v-divider class="mt-4" style="border-top: ridge;"></v-divider>
                    <v-row class="mt-5" style="align-items: center;">
                        <v-col cols="3" class="perfil-icon-col">
                            <v-icon color="orange" style="font-size:36px">mdi-star-circle</v-icon>
                        </v-col>
                        <v-col cols="9" class="text-left">
                            <p class="mb-1 perfil-seccion">Mis puntos</p>
                            <p class="mb-2 perfil-puntos">{{ puntos }} puntos</p>
                            <v-btn small outlined color="orange" @click="irCatalogo">VER CATÁLOGO</v-btn>
                            <p class="mt-3 mb-0 perfil-hint">
                                Realizá compras por la Aplicación de Ferrenet para ir sumando puntos
                            </p>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>
            <!--FOOTER---------------->
            <v-footer color="#ef6b01" padless fixed outlined class="mt-5" style="height: 57px;" rounded="0">
                <v-row justify="center" no-gutters>
                    <v-col cols="4"></v-col>
                    <v-col cols="4" class="text-center">
                        <v-btn style="bottom: 23px;" fab color="#ef6b01" elevation="20" @click="irHome" class="my-2"><font-awesome-icon style="font-size:25px;color: white" icon="plus"/></v-btn>
                    </v-col>
                    <v-col cols="4" class="text-end">
                        <v-btn @click="irCarrito" icon class="my-1 mr-2" color="white"><font-awesome-icon style="font-size:22px;color: white;" icon="cart-shopping"/>{{(carrito.length>0)?carrito.length:''}}</v-btn>
                    </v-col>
                </v-row>
            </v-footer>
        </v-card>
        <!-- ----CARGANDO------- -->
        <v-overlay :value="cargando">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import ApiServer from '../api';
import {mapState} from 'vuex'
export default {
    name:'MiPerfil',
    data(){
        return{
            cliente: null,
            transportes:[],
            cargando:false,
            puntos:0
        }
    },
    methods:{
        atras(){
            this.$router.go(-1)
        },
        irHome(){
            this.$router.push({name: 'Home'});
        },
        irCarrito(){
            this.$router.push({name: 'Carrito'});
        },
        irCatalogo(){
            this.$router.push({name: 'Catalogo'});
        }
    },
    async mounted(){
        try {
            this.cargando = true
                let result = await ApiServer.getDatosCliente(this.usuario.cod_cli)
                if(result.length>0){
                    let index = result.findIndex(x=>x.DOM_CLASIF_ID.trim()=='DE')
                    if(index>=0){
                        this.cliente = result[index]
                    }else{
                        this.cliente = result[0]
                    }
                }
                let respTransporte = await ApiServer.getTransportesCliente(this.usuario.cod_cli)
                this.transportes = respTransporte

                let respPuntos = await ApiServer.getPuntosCliente(this.usuario.cod_cli)
                console.log(respPuntos);
                if(respPuntos.length>0)
                this.puntos = respPuntos[0].puntos
                this.cargando = false
        } catch (error) {
            this.cargando = false
            console.log(error);
        }
    },
    computed:{
        ...mapState(['usuario','carrito']),
        nombreCompleto() {
            const nombre = this.usuario.nombre || ''
            const apellido = this.usuario.apellido || ''
            return `${nombre} ${apellido}`.trim() || 'Mi perfil'
        }
    }
}
</script>

<style scoped>
.fixed-bar {
    position: sticky;
    position: -webkit-sticky;
    top: 0em;
    z-index: 2;
}

.perfil-content {
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
}

.perfil-icon-col {
    display: grid;
    align-items: center;
    justify-items: center;
}

.perfil-nombre {
    font-size: 20px;
    font-weight: 800;
    line-height: 1.3;
}

.perfil-seccion {
    font-size: 18px;
    font-weight: 600;
    color: orange;
}

.perfil-dato {
    font-size: 17px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.75);
}

.perfil-puntos {
    font-size: 20px;
    font-weight: 700;
    color: #ef6b01;
}

.perfil-vacio,
.perfil-hint {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.55);
}

@media (min-width: 960px) {
    .perfil-content .v-row.mt-5 {
        margin-top: 12px !important;
    }
}
</style>
